export default __webpack_public_path__ + "edc8469deb49bc2c25d9ee477fc7bf64.png";